import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Login/login';
import { css } from '@patternfly/react-styles';
export var Login = function Login(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$footer = _a.footer,
      footer = _a$footer === void 0 ? null : _a$footer,
      _a$header = _a.header,
      header = _a$header === void 0 ? null : _a$header,
      props = __rest(_a, ["className", "children", "footer", "header"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.login, className)
  }), React.createElement("div", {
    className: css(styles.loginContainer)
  }, header, React.createElement("main", {
    className: css(styles.loginMain)
  }, children), footer));
};